// src/components/intake/IntakeShell.js
//
// Ticket 061 (Advisor Intake I4). The single-column layout every intake stage
// renders inside: two progress segments (Your info, Your money), a step label, a Back link, children.
// `wide` (Results only, ticket 069) lets the column hold the results rail.
// No AppShell, no fixed positioning, no viewport-height or width layout.
// The progress segments are in-flow and filled by class (no inline style).

import React from 'react'

const SEGMENTS = 2   // Your info, Your money. Review and Results are not segments (ticket 069)

export default function IntakeShell({ stepLabel, activeSegment, onBack, wide = false, children }) {
  return (
    <div className="intake-root">
      <div className={`intake-col${wide ? ' intake-col--wide' : ''}`}>
        <div className="intake-progress" aria-hidden="true">
          {Array.from({ length: SEGMENTS }, (_, i) => (
            <span
              key={i}
              className={`intake-progress-seg${i < activeSegment ? ' is-done' : ''}${i === activeSegment ? ' is-current' : ''}`}
            />
          ))}
        </div>
        <div className="intake-meta">
          <span className="triage-step-label">{stepLabel}</span>
          {onBack && (
            <button type="button" className="triage-back-link" onClick={onBack}>
              ← Back
            </button>
          )}
        </div>
        {children}
      </div>
    </div>
  )
}
